import posthog from 'posthog-js'
import * as Sentry from '@sentry/react'

let initialized = false

export function initAnalytics() {
  if (initialized) return

  const phKey  = import.meta.env.VITE_POSTHOG_KEY as string | undefined
  const phHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined
  const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined

  if (phKey && phHost) {
    posthog.init(phKey, {
      api_host: phHost,
      capture_pageview: false,
      persistence: 'localStorage+cookie',
      loaded: (ph) => { ph.capture('$pageview') },
    })
  }

  if (sentryDsn) {
    Sentry.init({
      dsn: sentryDsn,
      environment: import.meta.env.MODE,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      integrations: phKey ? [
        posthog.sentryIntegration({
          organization: 'bagcash',
          projectId: 4511436916981840,
        }) as any
      ] : [],
    })
  }

  initialized = true
}

export function identifyUser(userId: string, email?: string) {
  if (!initialized) return
  posthog.identify(userId, email ? { email } : undefined)
  Sentry.setUser({ id: userId, email })
}

export function trackPage(path: string) {
  if (!initialized) return
  posthog.capture('$pageview', { path })
}

export function trackEvent(event: string, props?: Record<string, unknown>) {
  if (!initialized) return
  posthog.capture(event, props)
}

export function resetAnalytics() {
  if (!initialized) return
  posthog.reset()
  Sentry.setUser(null)
}

export function optOut() {
  if (!initialized) return
  posthog.opt_out_capturing()
}
